import(/* webpackMode: "eager" */ "/opt/project/node_modules/bootstrap/dist/css/bootstrap.min.css");
;
import(/* webpackMode: "eager" */ "/opt/project/node_modules/bootstrap-icons/font/bootstrap-icons.min.css");
;
import(/* webpackMode: "eager" */ "/opt/project/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/opt/project/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/project/src/app/layout_router.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/project/src/app/query_client_wrapper.js");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/css/variables.css");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/css/theme.css");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/css/globals.css");
;
import(/* webpackMode: "eager" */ "/opt/project/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.js\",\"import\":\"Poppins\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"style\":[\"normal\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-poppins\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/opt/project/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.js\",\"import\":\"Dancing_Script\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":false,\"variable\":\"--font-dancing-script\"}],\"variableName\":\"dancingScript\"}");
;
import(/* webpackMode: "eager" */ "/opt/project/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.js\",\"import\":\"Playfair_Display\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"style\":[\"normal\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":false,\"variable\":\"--font-playfair-display\"}],\"variableName\":\"playfairDisplay\"}");
;
import(/* webpackMode: "eager" */ "/opt/project/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.js\",\"import\":\"Great_Vibes\",\"arguments\":[{\"weight\":[\"400\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":false,\"variable\":\"--font-great-vibes\"}],\"variableName\":\"greatVibes\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/project/src/components/common/consent/consent_managed_scripts.js");
;
import(/* webpackMode: "eager" */ "/opt/project/src/components/common/login_modal/login_modal.js");
;
import(/* webpackMode: "eager" */ "/opt/project/src/components/public_header/public_header.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/project/src/components/toast_container/toast_container.js");
;
import(/* webpackMode: "eager", webpackExports: ["ConsentProvider"] */ "/opt/project/src/providers/consent-context.js");
;
import(/* webpackMode: "eager", webpackExports: ["LoaderProvider"] */ "/opt/project/src/providers/loader-context.js");
;
import(/* webpackMode: "eager", webpackExports: ["ScreenContextProvider"] */ "/opt/project/src/providers/screen-context.js");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContextProvider"] */ "/opt/project/src/providers/toast-context.js");
